export const constants = {
  statsLimiter: 3,
}